import { Text } from '@billy/design-system'
import cc from 'classcat'
import React from 'react'

import { reactClass } from '../../utils'
import * as Styled from './styles'

export type ModalHeaderProps = {
  children?: React.ReactNode
  className?: string
  heading?: string
}

export const ModalHeader = ({ children = '', heading = '', className }: ModalHeaderProps) => (
  <Styled.ModalHeader className={cc([className, reactClass('modal-header')])}>
    {typeof children === 'string' ? <Text variant="h2">{children || heading || '.'}</Text> : children}
  </Styled.ModalHeader>
)
